// extracted by mini-css-extract-plugin
export default {"cls1":"lPy0Sr7YKTlBi8lua4sy","cls2":"EBn6PnUsPK09IRERjpQn lPy0Sr7YKTlBi8lua4sy","isPhoneRedesign":"gCIkwsvF8VrFw3PyWVlN"};